import common from './common/sagas'
import overview from './overview/sagas'
import create from './create/sagas'
import taskDetails from './taskDetails/sagas'
import projectDetails from './projectDetails/sagas'
import history from './history/sagas'

export default [common, overview, create, taskDetails, projectDetails, history]
